var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: "280px",
    height: "134px",
    viewBox: "0 0 280 134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0053057%",
    y1: "99.9526347%",
    x2: "50.0053057%",
    y2: "-0.0118413262%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.014966%",
    y1: "73.8751649%",
    x2: "49.276608%",
    y2: "22.1925044%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.0113616%",
    y1: "73.8668614%",
    x2: "49.2752729%",
    y2: "22.2336936%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.9841872%",
    y1: "79.5759074%",
    x2: "56.351491%",
    y2: "30.9061067%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "53.9873775%",
    y1: "73.881048%",
    x2: "49.2521534%",
    y2: "22.2325693%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.9789275%",
    y1: "79.5821388%",
    x2: "56.3462313%",
    y2: "30.9123382%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.9981697%",
    y1: "79.5455816%",
    x2: "56.3597638%",
    y2: "30.9207104%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "002.--Auto-Change-Instance",
    transform: "translate(-545.000000, -234.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-msg",
    transform: "translate(540.000000, 234.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_news_go0e",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(0.000000, 4.390244)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4954268,0 L36.1280488,19.1310976 C35.8406471,17.9476737 35.1708746,16.8921123 34.222561,16.1280488 C34.5666595,15.2060962 34.622479,14.2013457 34.382622,13.2469512 C34.3385492,12.9722087 34.2316019,12.7113617 34.070122,12.4847561 C33.762147,12.1958505 33.332126,12.076242 32.9192073,12.1646341 L28.2545732,12.4695122 C27.711436,12.4433783 27.1750696,12.5989246 26.7301829,12.9115854 C26.0746951,13.4603659 25.8765244,14.6112805 25.2057927,15.0990854 C24.7560976,15.4192073 24.1844512,15.3887195 23.6814024,15.6402439 C22.6067073,16.2118902 22.3704268,17.9268293 22.2865854,19.3216463 C22.1722561,21.2271341 22.179878,23.4679878 23.4222561,24.6570122 C24.3292683,25.5030488 25.5868902,25.4192073 26.7301829,25.3582317 L27.8810976,25.2667683 C28.1719761,25.4393863 28.4781499,25.5848189 28.7957317,25.7012195 L28.7957317,27.3246951 L28.5823171,27.3246951 C28.5823171,27.3246951 15.4192073,23.5137195 0.960365854,63.3307927 L0.708841463,63.3307927 C0.708841463,63.3307927 -1.42530488,70.5716463 1.98932927,69.2987805 C4.96189024,68.1859756 5.03810976,64.4740854 4.9847561,63.5442073 L5.18292683,63.5442073 C5.18292683,63.5442073 11.1509146,46.0746951 20.5259146,43.9405488 C20.5259146,43.9405488 27.347561,52.4618902 16.2652439,69.5045732 L24.9390244,69.5045732 C24.9115905,71.4113109 25.2963828,73.3014732 26.0670732,75.0457317 C28.6204268,80.160061 20.9527439,128.734756 20.9527439,128.734756 L27.347561,128.734756 L30.5640244,112.637195 L30.9679878,128.734756 L35.6554878,128.734756 L40.3429878,97.7820122 L39.7027439,60.4954268 L39.7027439,50.8384146 L40.5564024,51.9740854 L40.5564024,37.0579268 L52.9115854,37.0579268 L55.0457317,20.4420732 L54.8246951,20.4420732 C54.8769198,19.2815285 54.8284661,18.1186409 54.679878,16.9664634 L70.6097561,13.6204268 C73.117378,2.97256098 65.4954268,0 65.4954268,0 Z M51.5472561,20.7012195 L47.8125,30.2515244 C47.8125,30.2515244 37.5838415,25.5640244 33.75,27.2713415 L33.5365854,27.2713415 L33.5365854,25.2439024 C35.1288133,24.3238368 36.1599437,22.6728857 36.2881098,20.8384146 L51.6463415,17.6143293 C51.4475072,18.6285762 51.4114869,19.6680196 51.5396341,20.6935976 L51.5472561,20.7012195 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.8719512,27.5381098 C53.8719512,27.5381098 54.3597561,20.4954268 52.1646341,22.0426829 C49.9695122,23.589939 50.9146341,27.972561 50.9146341,27.972561 L53.8719512,27.5381098 Z",
    id: "Path",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36280488,67.7057927 C2.36280488,67.7057927 0.335365854,74.6036585 3.58231707,73.3917683 C6.82926829,72.179878 6.42530488,67.7057927 6.42530488,67.7057927 L2.36280488,67.7057927 Z",
    id: "Path",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FDA57D",
    x: 29.1615854,
    y: 30.7621951,
    width: 4.46646341,
    height: 4.0625
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4D8AF0",
    x: 25.5030488,
    y: 53.0945122,
    width: 3.65091463,
    height: 18.2698171
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0.1,
    x: 25.5030488,
    y: 53.0945122,
    width: 3.65091463,
    height: 18.2698171
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8993902,33.4070122 L35.1219512,33.4070122 C37.5424065,33.4070122 39.5045732,35.3691789 39.5045732,37.7896341 L39.5045732,65.0685976 L26.5472561,65.0685976 L26.5472561,37.7896341 C26.5472561,35.3810353 28.4908497,33.4237677 30.8993902,33.4070122 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FDA57D",
    cx: 30.9832317,
    cy: 26.9054878,
    r: 5.27439024
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9557927,33.4070122 C28.9557927,33.4070122 16.3719512,29.7560976 2.56859756,67.9115854 L6.63109756,67.9115854 C6.63109756,67.9115854 12.3170732,51.2652439 21.242378,49.2378049 C21.242378,49.2378049 27.7362805,57.3551829 17.179878,73.6280488 L25.7088415,73.6280488 L25.7088415,68.1859756 C25.6591339,59.9377653 26.6840156,51.718214 28.757622,43.7347561 C29.7355163,40.3702272 29.8038962,36.8065787 28.9557927,33.4070122 Z",
    id: "Path",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8262195,33.4070122 L33.8262195,34.6265244 C33.8262195,34.6265244 36.6692073,47.2103659 39.1006098,55.3277439 L40.3429878,56.9817073 L40.3429878,42.7439024 L52.1189024,42.7439024 L54.1463415,26.9131098 L50.8993902,26.9131098 L47.2027439,36.242378 C47.2027439,36.242378 37.4771341,31.7759146 33.8262195,33.4070122 Z",
    id: "Path",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5167683,65.0685976 C26.5167683,65.0685976 24.0777439,74.0015244 26.5167683,78.8719512 C28.9557927,83.742378 21.6463415,130.022866 21.6463415,130.022866 L27.7439024,130.022866 L36.4710366,86.3795732 L37.8887195,65.0381098 L26.5167683,65.0685976 Z",
    id: "Path",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#333333",
    points: "39.5121951 65.0685976 40.1219512 100.58689 35.6554878 130.022866 31.1890244 130.022866 29.5655488 65.0685976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1219512,24.8932927 C30.2301306,24.7171556 30.3636795,24.5579243 30.5182927,24.4207317 C30.670864,24.3312509 30.8444667,24.2839047 31.0213415,24.2835366 C32.1265244,24.1920732 33.3993902,24.1692073 34.070122,23.125 C34.5630233,22.187591 34.6828391,21.0983563 34.4054878,20.0762195 C34.3693414,19.8018944 34.2673542,19.5403888 34.1082317,19.3140244 C33.8145668,19.0384616 33.4043873,18.9245229 33.0106707,19.0091463 L28.5670732,19.2987805 C28.0589777,19.2794164 27.5584731,19.4266237 27.1417683,19.7179878 C26.5167683,20.2439024 26.3338415,21.3338415 25.6783537,21.8064024 C25.2439024,22.1112805 24.7027439,22.0807927 24.2454268,22.3246951 C23.2240854,22.8658537 23.0030488,24.4817073 22.9192073,25.8307927 C22.8125,27.6448171 22.8125,29.7789634 24.0015244,30.8841463 C24.8628049,31.6920732 26.0594512,31.6463415 27.1493902,31.554878 L29.1768293,31.3871951 C29.3814045,31.3927197 29.5821683,31.3311521 29.7484756,31.2118902 C30.0078997,30.8652278 30.1076646,30.4245997 30.0228659,30 C29.9695122,28.9786585 29.8628049,27.820122 29.1920732,27.195122 C29.0320652,27.0749068 28.8863044,26.9368176 28.757622,26.7835366 C28.0335366,25.6554878 29.7408537,25.3963415 30.1219512,24.8932927 Z",
    id: "Path",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5960366,6.67682927 C64.5960366,6.67682927 71.9054878,9.51981707 69.4664634,19.6341463 L36.5853659,26.5320122 L36.5853659,24.9085366 L64.5960366,6.67682927 Z",
    id: "Path",
    fill: "#7DC4FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-2)",
    points: "100.724085 4.6570122 101.295732 4.36737805 101.158537 4.35213415 101.204268 4.32164634 101.120427 4.3445122 85.3887195 2.30945122 85.7240854 7.5152439 86.2195122 12.1341463 87.1875 11.6387195 88.0868902 13.6814024"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "86.25 7.41615854 86.7073171 11.6463415 100.769817 4.51981707 88.5594512 4.78658537"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.2,
    points: "86.25 7.41615854 86.7073171 11.6463415 100.769817 4.51981707 88.5594512 4.78658537"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "85.9375 2.65243902 100.769817 4.51981707 86.25 7.41615854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "88.445122 13.0487805 100.685976 4.47408537 86.4939024 8.69664634"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    points: "176.996951 2.86585366 177.568598 2.57621951 177.431402 2.55335366 177.477134 2.52286585 177.393293 2.55335366 161.653963 0.518292683 161.996951 5.72408537 162.492378 10.3429878 163.460366 9.84756098 164.359756 11.8902439"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "162.522866 5.625 162.980183 9.85518293 177.042683 2.72865854 164.832317 2.99542683"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.2,
    points: "162.522866 5.625 162.980183 9.85518293 177.042683 2.72865854 164.832317 2.99542683"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "162.210366 0.861280488 177.042683 2.72865854 162.522866 5.625"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "164.717988 11.257622 176.958841 2.68292683 162.766768 6.89786585"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    points: "246.310976 19.9466463 246.935976 19.8018293 246.806402 19.7560976 246.859756 19.7332317 246.768293 19.7332317 231.989329 13.9710366 231.067073 19.1082317 230.434451 23.7042683 231.493902 23.4603659 231.867378 25.6554878"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "231.60061 19.1387195 231.021341 23.3460366 246.387195 19.8246951 234.474085 17.1417683"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.2,
    points: "231.60061 19.1387195 231.021341 23.3460366 246.387195 19.8246951 234.474085 17.1417683"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "232.446646 14.4359756 246.387195 19.8246951 231.60061 19.1387195"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "232.370427 25.1295732 246.318598 19.7560976 231.52439 20.4344512"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(194.054878, 71.463415)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-5)",
    points: "15.3429878 2.76676829 15.9070122 2.4695122 15.777439 2.45426829 15.8155488 2.42378049 15.7317073 2.44664634 0 0.411585366 0.342987805 5.625 0.838414634 10.2362805 1.80640244 9.74085366 2.69817073 11.7835366"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "0.868902439 5.52591463 1.32621951 9.74847561 15.3887195 2.62195122 3.17835366 2.88871951"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.2,
    points: "0.868902439 5.52591463 1.32621951 9.74847561 15.3887195 2.62195122 3.17835366 2.88871951"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "0.556402439 0.754573171 15.3887195 2.62195122 0.868902439 5.52591463"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "3.06402439 11.1509146 15.304878 2.57621951 1.11280488 6.79878049"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(262.469512, 81.371951)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-6)",
    points: "16.3567073 6.47103659 16.9817073 6.31859756 16.8521341 6.27286585 16.9054878 6.25 16.8140244 6.25762195 2.03506098 0.487804878 1.11280488 5.625 0.480182927 10.2286585 1.5320122 9.97713415 1.91310976 12.1722561"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "1.64634146 5.6554878 1.06707317 9.86280488 16.4329268 6.34146341 4.51981707 3.65853659"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.2,
    points: "1.64634146 5.6554878 1.06707317 9.86280488 16.4329268 6.34146341 4.51981707 3.65853659"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "2.49237805 0.952743902 16.4329268 6.34146341 1.64634146 5.6554878"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "2.41615854 11.6539634 16.3643293 6.2804878 1.57012195 6.95121951"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(114.329268, 15.823171)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-7)",
    points: "16.3185976 6.63871951 16.9435976 6.49390244 16.8140244 6.44054878 16.867378 6.42530488 16.7759146 6.42530488 1.99695122 0.663109756 1.07469512 5.80030488 0.43445122 10.3963415 1.50152439 10.1448171 1.875 12.347561"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "1.60823171 5.83079268 1.02896341 10.0381098 16.3948171 6.51676829 4.48170732 3.83384146"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    points: "1.60823171 5.83079268 1.02896341 10.0381098 16.3948171 6.51676829 4.48170732 3.83384146"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "2.45426829 1.12804878 16.3948171 6.51676829 1.60823171 5.83079268"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6C63FF",
    points: "2.37804878 11.8216463 16.3262195 6.44817073 1.5320122 7.12652439"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleMan);
export default __webpack_public_path__ + "static/media/purple-man.28c7882e33317cbdc28cb5fa83869da2.svg";
export { ForwardRef as ReactComponent };